import React from "react";
import DataTable from "../../../components/DataTable";
const dataJson = [
  {
    id: "4347348",
    sn: "01",
    totalLeft: "45",
    totalRight: "47",
    leftCF: "21",
    matchingBonus: "$145",
    amount: "$48",
    date: "08/03/2022",
    txnNumber: "dfs7f8sf5d",
  },
  {
    id: "fs7fd8sf",
    sn: "02",
    totalLeft: "45",
    totalRight: "47",
    leftCF: "21",
    matchingBonus: "$145",
    amount: "$48",
    date: "08/03/2022",
    txnNumber: "fsf7sf",
  },
  {
    id: "dfsfsf7",
    sn: "03",
    totalLeft: "45",
    totalRight: "47",
    leftCF: "21",
    matchingBonus: "$145",
    amount: "$48",
    date: "08/03/2022",
    txnNumber: "sfs8fsf8",
  },
];

const columns = [
  { id: "sn", label: "S.N", minWidth: 20 },
  { id: "totalLeft", label: "Total Left", minWidth: 100 },
  {
    id: "totalRight",
    label: "Total Right",
    minWidth: 80,
  },
  {
    id: "leftCF",
    label: "Left C/F",
    minWidth: 80,
  },
  {
    id: "matchingBonus",
    label: "Matching Bonus",
    minWidth: 100,
  },
  {
    id: "amount",
    label: "Amount",
    minWidth: 100,
  },
  {
    id: "date",
    label: "Date",
    minWidth: 100,
  },
  {
    id: "txnNumber",
    label: "Txn Number",
    minWidth: 100,
  },
];

function createData(
  sn,
  totalLeft,
  totalRight,
  leftCF,
  matchingBonus,
  amount,
  date,
  txnNumber
) {
  return {
    sn,
    totalLeft,
    totalRight,
    leftCF,
    matchingBonus,
    amount,
    date,
    txnNumber,
  };
}

const rows = dataJson.map((d) =>
  createData(
    d.sn,
    d.totalLeft,
    d.totalRight,
    d.leftCF,
    d.matchingBonus,
    d.amount,
    d.date,
    d.txnNumber
  )
);

const MatchingBonusTable = () => {
  return (
    <DataTable
      columns={columns}
      rows={rows}
      perPageShow={6}
      tableHeight={440}
      className="common_table"
    />
  );
};

export default MatchingBonusTable;
